// 挽留弹窗
import React, { useEffect } from 'react';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { closeModal, showIndependentModal } from 'lib/components/Modal';
import Dialog from 'lib/components/DialogV2';
import OrderGoods from '../OrderGoods/OrderGoods';
import './index.scss';

const DetainModal = ({ packageId, closeCallback, closeModal: closeCurrentModal }) => {
  useEffect(() => {
    report(ATTA_REPORT.ORDER_RETAIN.RETAIN_ORDER_PV);
  }, []);
  const cancelCallback = () => {
    report(ATTA_REPORT.ORDER_RETAIN.RETAIN_BACK_CLICK);
    // 关闭两个弹窗
    closeCurrentModal();
    closeModal();
    closeCallback();
  };
  const confirmCallback = () => {
    report(ATTA_REPORT.ORDER_RETAIN.RETAIN_ORDER_CLICK);
    closeCurrentModal();
    // 关闭当前弹窗
  };
  return (
    <Dialog
      showClose={false}
      customClass={'retain-modal'}
      title={<span className="retain-modal-content__title">只差最后一步即可领限时福利</span>}
      keyboard={{ onEnter: confirmCallback, onEscape: cancelCallback }}
    >
      <div className="retain-modal-content">
        <OrderGoods packageId={packageId} />
        <div className="confirm-out">确认退出吗？</div>
        <div className="retain-modal__footer">
          <div className="retain-modal__footer-cancel button cancel" onClick={cancelCallback}>
            忍痛离开
          </div>
          <div className="retain-modal__footer-confirm button confirm" onClick={confirmCallback}>
            继续领取
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export function showDetainModal(params) {
  return showIndependentModal(<DetainModal {...params} />);
}
